/**
 * .datepicker
 * Bind datepickers
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

$(function()
{
    "use strict";

    // Enforce default formatting
    $.fn.datepicker.defaults.format = "mm/dd/yyyy";

    // Always disable weekends
    // $.fn.datepicker.defaults.daysOfWeekDisabled = [0, 6];

    // Close on Click
    $.fn.datepicker.defaults.autoclose = true;

    // Display on top of all things
    $.fn.datepicker.defaults.zIndexOffset = 10;

    // Always start with left and below
    $.fn.datepicker.defaults.orientation = "bottom left";

    // Lazy loading:
    // Add data-provide="datepicker" to an element to enable the datepicker
    // $('.datepicker').datepicker();
});

